'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChangeEvent, CompositionEvent } from 'react';
import { useRef } from 'react';
interface TickerInputHandlers {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onCompositionStart: () => void;
  onCompositionEnd: (event: CompositionEvent<HTMLInputElement>) => void;
}
export function useUppercaseTickerInput(onValueChange) {
  const $ = _c(8);
  const composing = useRef(false);
  let t0;
  if ($[0] !== onValueChange) {
    t0 = function onChange(event) {
      const isComposing = composing.current || event.nativeEvent instanceof InputEvent && event.nativeEvent.isComposing;
      onValueChange(isComposing ? event.currentTarget.value : uppercaseTickerInput(event.currentTarget));
    };
    $[0] = onValueChange;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onChange = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function onCompositionStart() {
      composing.current = true;
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onCompositionStart = t1;
  let t2;
  if ($[3] !== onValueChange) {
    t2 = function onCompositionEnd(event_0) {
      composing.current = false;
      onValueChange(uppercaseTickerInput(event_0.currentTarget));
    };
    $[3] = onValueChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onCompositionEnd = t2;
  let t3;
  if ($[5] !== onChange || $[6] !== onCompositionEnd) {
    t3 = {
      onChange,
      onCompositionStart,
      onCompositionEnd
    };
    $[5] = onChange;
    $[6] = onCompositionEnd;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function uppercaseTickerInput(input: HTMLInputElement): string {
  const value = input.value;
  const uppercase = value.toUpperCase();
  if (uppercase !== value) {
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const direction = input.selectionDirection;
    // Match the controlled value before React commits so it retains the selection.
    input.value = uppercase;
    if (start !== null && end !== null) {
      // Browser offsets count UTF-16 units; uppercase can expand letters like ß.
      input.setSelectionRange(value.slice(0, start).toUpperCase().length, value.slice(0, end).toUpperCase().length, direction ?? undefined);
    }
  }
  return uppercase;
}